import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { ProductGateway } from "@/components/site/ProductGateway";
import { CorporateStrengths } from "@/components/site/CorporateStrengths";
import { ProductPageHero } from "@/components/site/ProductPageHero";
import { AcrylicStrengths } from "@/components/site/AcrylicStrengths";
import { GalvalumPage } from "@/components/site/GalvalumPage";
import { Products } from "@/components/site/Products";
import { UVProtection } from "@/components/site/UVProtection";
import { Applications } from "@/components/site/Applications";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Partnership } from "@/components/site/Partnership";
import { CompanyProfile } from "@/components/site/CompanyProfile";
import { SalesTeam } from "@/components/site/SalesTeam";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

const ScrollToTarget = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      window.setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 0);
      return;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

const HomePage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <CompanyProfile />
        <ProductGateway />
        <CorporateStrengths />
        <Testimonials />
        <Partnership />
        <SalesTeam />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

const AnimaxAcrylicPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="animax-acrylic-page">
      <Navbar />
      <main>
        <ProductPageHero />
        <AcrylicStrengths />
        <Products />
        <UVProtection />
        <Applications />
        <Gallery />
        <SalesTeam />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

const BajaRinganGalvalumPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="baja-ringan-galvalum-page">
      <Navbar />
      <main>
        <GalvalumPage />
        <SalesTeam />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTarget />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/produk/animax-acrylic-sheet" element={<AnimaxAcrylicPage />} />
          <Route path="/produk/baja-ringan-galvalum" element={<BajaRinganGalvalumPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
